import Vue from "vue"
import Vuex from 'vuex'

// 1.安装插件
Vue.use(Vuex)

// 2.创建对象
const store = new Vuex.Store({
    state:{
        // 蓝色
        baseColor: "#3949AB",//基本色调
        baseSecondColor: "#303F9F",//用户中心界面，用户名，编号的背景色
        // 浅绿色
        // baseColor: "#2EDFA3",//基本色调
        // baseSecondColor: "#1EC188",//用户中心界面，用户名，编号的背景色

        // titleFontSize:"large",
        // inputFontSize:"x-small",
        // buttonSize:"x-small",
        titleFontSize:"1.125rem",// 18px
        inputFontSize:"0.75rem",// 12px
        buttonSize:"0.75rem",// 12px
        pageTitleColor:"#5A5A5A",


        // loginPageWidth: "320px",// 20 X 16px = 320px
        // loginPageHeight: "210px",// 12.5 X 16px = 200px
        loginPageWidth: "85vw",// 20 X 16px = 320px
        loginPageHeight: "29vh",// 12.5 X 16px = 200px
        // loginPageWidth: "20rem",// 20 X 16px = 320px
        // loginPageHeight: "12.5rem",// 12.5 X 16px = 200px

        // 显示加载中动画
        showLoading: false,
        commonParameters: {},// 客户端传过来的基本参数，网络请求时需要
        protocolTitle: "",// 接口返回的注册协议标题
        protocolUrl: "",// 接口返回的注册协议内容链接
        policyTitle: "",// 接口返回的隐私政策标题
        policyUrl: "",// 接口返回的隐私政策内容链接
        savingAccounts:[],//已存在的账号
        
        // 显示加载中动画
        showLoading: false,
        
        // 显示toast
        showToast: false,
        toastMessage: "toast文字",
        agreeChecked: false,//是否勾选阅读协议

        getCodePhoneNum: "",//获取验证码的手机
        tokenLoginFailedAccount: "",//token登录失败时的账号
        switchPageToFirstPage: false, // 标识当前是从切换账号界面跳转到登录首页的
        showAgreeDialog: false,// 是否需要显示注册协议或隐私政策
        showAgreeTitle: "",// 需要显示注册协议或隐私政策的title
        showAgreeUrl: "",// 需要显示注册协议或隐私政策的url
        rid: "",// 用户信息接口返回的rid
        phone:"",//用户信息接口返回的手机号，可用于判断当前账号是否已经绑定了手机
        changePswPageVisiable: true,// 是否需要显示修改密码界面，因为修改完成后要隐藏，但是路由我无法确定要怎么处理隐藏
       },
    mutations:{
        // 切换加载中动画
        switchLoading(state, showOrHide){
            state.showLoading = showOrHide;
        },
        // 接收客户端传来的数据，并将角色数据赋值给 roleInfoData 
        updateCommonParams(state, payload){
            // console.log(payload)
            let paramJson = JSON.parse(payload);
            state.commonParameters = paramJson;
            // Vue.set(state.commonParameters, JSON.parse(payload))
            if (typeof(paramJson['savingAccounts']) !== "undefined") {
                state.savingAccounts = JSON.parse(paramJson['savingAccounts'])
            }
        },
        // 切换toast
        switchToast(state, payload){
            state.showToast = payload["showOrHide"];
            state.toastMessage = payload["toastMessage"];
        },
        // 更新全局的是否阅读并同意 注册协议和隐私政策
        changeAgreeCheckState(state, payload){
            state.agreeChecked = payload;
        },
        // 更新注册协议或隐私政策是title和url,是从接口返回的
        UpdateProtocolAndPolicy(state, payload){
            state.protocolTitle = payload['protocol']['title'];
            state.protocolUrl = payload['protocol']['url'];
            state.policyTitle = payload['policy']['title'];
            state.policyUrl = payload['policy']['url'];
        },
        // 获取手机验证的手机号，需要在手机验证码登录时显示出来
        updateGetCodePhoneNum(state,payload){
            state.getCodePhoneNum = payload;
        },
        // token 登录失败的账号，需要在对应的账号登录页面显示这个账号
        updateTokenLoginFailedAccount(state,payload){
            state.tokenLoginFailedAccount = payload;
        },
        // 标志，是从切换账号跳转到首页的，需要在首页显示关闭的按钮
        switchPageToFirstPage(state, payload){
            state.switchPageToFirstPage = payload;
        },
        // 点击了注册协议还是隐私政策
        updateClickAgreeType(state, payload){
            if ("protocol" === payload) {
                state.showAgreeTitle = state.protocolTitle;
                state.showAgreeUrl = state.protocolUrl;
                state.showAgreeDialog = true;
            }else if ("policy" === payload) {
                state.showAgreeTitle = state.policyTitle;
                state.showAgreeUrl = state.policyUrl;
                state.showAgreeDialog = true;
            }
        },
        // 关闭注册协议或隐私政策的窗口
        updateShowAgreeDialogStatus(state, payload){
            state.showAgreeDialog = payload;
        },
        //更新rid和phone
        UpdateRidAndPhone(state, payload){
            state.rid = payload["rid"];
            state.phone = payload["phone"];
            state.commonParameters['rid'] = payload["rid"];
            state.commonParameters["phone"] = payload["phone"];
        },
        updateChangePswPageVisible(state, payload){
            state.changePswPageVisiable = payload;
        },
        // 更新登录界面的宽高
        updateLoginPageSize(state, payload){
            state.loginPageWidth = "45vw";
            state.loginPageHeight = "55vh";
        },
        // 更新登录界面的宽高
        updateLoginPageSizeWithValue(state, payload){
            if (payload['screenWidth']) {
                state.loginPageWidth = payload['screenWidth'];
            }
            if (payload['screenHeight']) {
                state.loginPageHeight = payload['screenHeight'];
            }
        }
    },
    actions:{
        // 获取rid和phone后，更新到基本参数中
        networkUpdateProtocolAndPolicy(context, payload){
            context.commit('UpdateProtocolAndPolicy', payload);
        },
        // 获取rid和phone后，更新到基本参数中
        networkUpdateRid(context, payload){
            context.commit('UpdateRidAndPhone', payload);
        },
        // 设置修改密码页面的显示状态
        networkUpdateChangePswPageVisible(context, payload){
            context.commit('updateChangePswPageVisible', payload);
        }
    },
    getters:{
        
    },
    modules:{
        
    }
})

// 3.导出
export default store


// WEBPACK FOOTER //
// ./src/normal/store/index.js